import {uiManager} from '../../EntryHomepage'
import {UIDFooterController} from '../UIDFooterController'
import {Scene} from '../UISceneTypes'
import {UIDHeaderCoinController} from './UIDHeaderCoinController'
import {UIWHeaderController} from './UIWHeaderController'

export class UIDHeaderController extends UIWHeaderController {
    protected override setButtonsActions(): void {
        this.homeButton = document.getElementById('header_navigation_home') as HTMLLinkElement
        this.lobbyButton = document.getElementById('header_navigation_lobby') as HTMLLinkElement
        this.leaderboardButton = document.getElementById('header_navigation_leaderboard') as HTMLLinkElement
        this.storeButton = document.getElementById('header_navigation_store') as HTMLLinkElement
        const logo = document.getElementById('header_logo_discord') as HTMLLinkElement

        this.homeButton.onclick = () => {
            this.visitHome()
        }

        this.lobbyButton.onclick = () => {
            this.visitLobby()
        }

        this.leaderboardButton.onclick = () => {
            this.visitLeaderboard()
        }

        this.storeButton.onclick = () => {
            this.visitStore()
        }

        logo.onclick = () => {
            if(uiManager.sceneController.scene == Scene.Room) {
                uiManager.room.leaveRoom(Scene.MainPage)
                return
            }
            uiManager.sceneController.loadScene(Scene.MainPage)
        }
    }

    protected override setCoinController() {
        this.coinController = new UIDHeaderCoinController(() => this.visitStore())
    }

    override activateHomeButton() {
        this.deactivateAllButtons()
        if(this.homeButton != undefined) this.homeButton.classList.add('active')
    }

    activateLobbyButton() {
        this.deactivateAllButtons()
        if(this.lobbyButton != undefined) this.lobbyButton.classList.add('active')
    }

    activateLeaderboardButton() {
        this.deactivateAllButtons()
        if(this.leaderboardButton != undefined) this.leaderboardButton.classList.add('active')
    }

    activateStoreButton() {
        this.deactivateAllButtons()
        if(this.storeButton != undefined) this.storeButton.classList.add('active')
    }

    deactivateAllButtons() {
        if(this.homeButton != undefined) this.homeButton.classList.remove('active')
        if(this.lobbyButton != undefined) this.lobbyButton.classList.remove('active')
        if(this.leaderboardButton != undefined) this.leaderboardButton.classList.remove('active')
        if(this.storeButton != undefined) this.storeButton.classList.remove('active')
        if(uiManager?.footer instanceof UIDFooterController) uiManager.footer.deactivateAllButtons()
    }

    private visitHome() {
        this.activateHomeButton()
        this.closeMobileMenu()
        if(uiManager.sceneController.scene == Scene.Room) {
            uiManager.room.leaveRoom(Scene.MainPage)
            return
        }
        uiManager.sceneController.loadScene(Scene.MainPage)
    }

    private visitLobby() {
        this.activateLobbyButton()
        this.closeMobileMenu()
        if(uiManager.sceneController.scene == Scene.Room) {
            uiManager.room.leaveRoom(Scene.Lobby)
            return
        }
        uiManager.sceneController.loadScene(Scene.Lobby)
    }

    private visitLeaderboard() {
        this.activateLeaderboardButton()
        this.closeMobileMenu()
        if(uiManager.sceneController.scene == Scene.Room) {
            uiManager.room.leaveRoom(Scene.DiscordLeaderboard)
            return
        }
        uiManager.sceneController.loadScene(Scene.DiscordLeaderboard)
    }

    private visitStore() {
        this.activateStoreButton()
        this.closeMobileMenu()
        if(uiManager.sceneController.scene == Scene.Room) {
            uiManager.room.leaveRoom(Scene.DiscordStore)
            return
        }
        uiManager.sceneController.loadScene(Scene.DiscordStore)
    }
}
